export default {
  url_api: process.env.VUE_APP_URL_API || 'http://iam.issues.suporte.connectintegra.com.br/api/v1',
  credentials: {},
  token:  ''
}
